import { render, staticRenderFns } from "./travelBus.vue?vue&type=template&id=1fd6820c&scoped=true&"
import script from "./travelBus.vue?vue&type=script&lang=js&"
export * from "./travelBus.vue?vue&type=script&lang=js&"
import style0 from "./travelBus.vue?vue&type=style&index=0&id=1fd6820c&scoped=true&lang=css&"
import style1 from "./travelBus.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd6820c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardText,VChip,VChipGroup,VProgressCircular,VTooltip})
